__turbopack_context__.v({
  "fadeIn": "NqnXWq_fadeIn",
  "fadeInText": "NqnXWq_fadeInText",
  "h1": "NqnXWq_h1",
  "h2": "NqnXWq_h2",
  "h3": "NqnXWq_h3",
  "sectionMargin": "NqnXWq_sectionMargin",
  "titleH": "NqnXWq_titleH",
});
